export default __webpack_public_path__ + "static/media/fiord28.98d57809.jpg";